// user/src/features/lottery/AllGlobalWinners.jsx
import { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  query,
  orderBy,
  limit,
  onSnapshot,
  startAfter,
  getDocs,
} from "firebase/firestore";

export default function AllGlobalWinners() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const qy = query(
      collection(db, "draws"),
      orderBy("drawnAt", "desc"),
      limit(60)
    );
    return onSnapshot(qy, (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setRows(arr);
    });
  }, []);
  return (
    <div className="max-w-2xl mx-auto mt-8 md:mt-20">
      <h1 className="text-2xl font-bold mb-4">Previous Winning Numbers</h1>
      <div className="grid md:grid-cols-2 gap-3">
        {rows.map((r) => (
          <div
            key={r.id}
            className="p-4 rounded-xl bg-slate-800 flex items-center justify-between"
          >
            <div className="font-semibold">{r.id}</div>
            <div className="rounded-full px-3 py-1 bg-yellow-300 text-black font-bold text-lg">
              {String(r.winningNumber).padStart(2, "0")}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
